import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import "./UnitLayout.css";
import UnitImage from "../../../Images/cat.jpg";
import Problem from "../../../ProblemLayout/Problem";
import HintsPage from "./HintLayout/HintsPage";
import { renderStatementWithKaTeX } from "../../../../Functions/WriteLaTex";
import { GiSpades, GiHearts, GiTruce } from "react-icons/gi";
import FeedbackForm from "./FeedbackForm/FeedbackForm";
import { GettingUnitById } from "../../../../Functions/CRUD/Units/unitsHelper";
import { useLoading } from "../../../../context/loadingContext";
import LoadingPage from "../../../../Error/LoadingPage/LoadingPage";
import AddProblemToUnit from "./AddProblemToUnit/AddProblemToUnit";
import { AuthContext } from "../../../../context/authContext";
const UnitLayout = () => {
  const { loading, setLoading } = useLoading();
  
  const [unit, setunit] = useState(null);
  const { unitId } = useParams();
  const {user}=useContext(AuthContext)

  const [NavigationButtonsStatus, setNavigationButtonsStatus] =
    useState("Problems");

  const fetchUnit = async () => {
    const data = await GettingUnitById(unitId);
    // Define the difficulty order
  const order = { Easy: 1, Medium: 2, Hard: 3 };

  // Sort problems by difficulty
  const sortedProblems = [...data.problems].sort(
    (a, b) => order[a.difficulty] - order[b.difficulty]
  );

  // Set the sorted data
  setunit({ ...data, problems: sortedProblems });
    
  };

  useEffect(() => {
    fetchUnit();
  }, [unitId]);
  if (!unit) {
    return <LoadingPage/>
  }

  

  return (
    <div className="UnitLayout-container">
      <div className="Header">
        <img src={UnitImage} alt="" />
        <div className="Discription">
          <h1>
            {unit.field}: {unit.title}
          </h1>
          {/* Title */}
          <p>{unit.description}</p>
          {/* Discription */}
          <div className="Statistics">
            <span>
              <b>Last Updated :</b>{" "}
              {new Date(unit.lastEdited).toLocaleDateString("en-GB")}
            </span>
            <span>
              <b>Number of Problems :</b> {unit.problems.length}
            </span>

            <button>Download pdf</button>
          </div>
        </div>
      </div>
     {/*<hr />*/}
      <div className="UnitProblem-container">
        <div className="UnitProblem-container-Buttons">
          <div className="borderbottom"></div>
          <button
            className={NavigationButtonsStatus === "Problems" ? "Active" : null}
            onClick={() => setNavigationButtonsStatus("Problems")}
          >
            Problems
          </button>
          <button
            className={NavigationButtonsStatus === "Hints" ? "Active" : null}
            onClick={() => setNavigationButtonsStatus("Hints")}
          >
            Hints
          </button>
          {/* <button
            className={NavigationButtonsStatus === "Feedback" ? "Active" : null}
            onClick={() => setNavigationButtonsStatus("Feedback")}
          >
            Feedback
          </button> */}
        </div>
        <div className="Body">
          {NavigationButtonsStatus === "Problems" ? (
            <div className="">
              <div className="title">
                <GiSpades style={{ fontSize: "2em", color: "#48182fef" }} />
                <h2 style={{ fontSize: "2.3em", color: "#48182fc1" }}>
                  {" "}
                  Unit Problems :
                </h2>
              </div>

              {unit?.problems?.length===0? <p className="NoProblem">No problems are posted yet for this unit.</p>:unit?.problems?.map((p) => (
                <Problem problem={p} />
              ))}

              <hr />
              {user?.role.trim().toLowerCase()==="admin"?<AddProblemToUnit length={unit.problems.length}/>:null}
            </div>
          ) : NavigationButtonsStatus === "Hints" ? (
            <div className="">
              <div className="title">
                <GiHearts style={{ fontSize: "2em", color: "#48182fef" }} />
                <h2 style={{ fontSize: "2.3em", color: "#48182fc1" }}>
                  Problem Hints :
                </h2>
              </div>
              <div className="hints-container">
                {unit?.problems?.length===0? <p className="NoProblem">No problems are posted yet for this unit. Thus no hints are available.</p>:unit?.problems?.map((item, index) => (
                  <HintsPage key={index} problem={{problemTitle:`${unit.field}: ${unit.title} - (${item.referenceCode})`,hints : item.hint}} />
                ))}
              </div>
            </div>
          ) : (
            <div className="">
              <div className="title">
                <GiHearts style={{ fontSize: "2em", color: "#48182fef" }} />
                <h2 style={{ fontSize: "2.3em", color: "#48182fc1" }}>
                  Share your thoughts :
                </h2>
              </div>
              <FeedbackForm />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnitLayout;
